import axios from "axios";
import { authenticatedApiConfig } from "./BaseApiService";
export class LoincService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async getLoincs(type, descriptionPrefix, limit) {
        const response = await axios.get(`${this.environment.API_BASE_URL}/loincs/type/${type}?descriptionPrefix=${descriptionPrefix}&limit=${limit}`, authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async getLoinc(loincCode) {
        const response = await axios.get(`${this.environment.API_BASE_URL}/loincs/${loincCode}`, authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async getValuesForLoinc(loincCode, descriptionPrefix, limit) {
        const response = await axios.get(`${this.environment.API_BASE_URL}/loincs/${loincCode}/values?descriptionPrefix=${descriptionPrefix}&limit=${limit}`, authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
}
